import { IconCreditCard, IconQrcode, IconWallet, type Icon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { TopupMethod } from '../methodTheme';

interface MethodCardsProps {
    method: TopupMethod;
    onChange: (method: TopupMethod) => void;
}

interface MethodCardConfig {
    key: TopupMethod;
    icon: Icon;
    labelKey: string;
    taglineKey: string;
}

const METHODS: MethodCardConfig[] = [
    {
        key: 'promptpay',
        icon: IconQrcode,
        labelKey: 'methods.promptpay.label',
        taglineKey: 'methods.promptpay.tagline',
    },
    {
        key: 'truewallet',
        icon: IconWallet,
        labelKey: 'methods.truewallet.label',
        taglineKey: 'methods.truewallet.tagline',
    },
    // {
    //     key: 'internetBank',
    //     icon: IconBuildingBank,
    //     labelKey: 'methods.internetBank.label',
    //     taglineKey: 'methods.internetBank.tagline',
    // },
    {
        key: 'creditCard',
        icon: IconCreditCard,
        labelKey: 'methods.creditCard.label',
        taglineKey: 'methods.creditCard.tagline',
    },
];

export default function MethodCards({ method, onChange }: MethodCardsProps) {
    const { t } = useTranslation('topup');

    return (
        <div
            role="radiogroup"
            aria-label={t('methods.heading')}
            className="w-full flex flex-col gap-2 p-4"
        >
            {METHODS.map(({ key, icon: Icon, labelKey, taglineKey }) => {
                const selected = key === method;
                return (
                    <button
                        key={key}
                        type="button"
                        role="radio"
                        aria-checked={selected}
                        onClick={() => onChange(key)}
                        className={[
                            'relative flex flex-col gap-2 rounded-lg border p-4 text-left transition',
                            selected
                                ? 'border-blue-500 ring-2 ring-blue-500/30 bg-fg/2'
                                : 'border-fg/15 hover:border-fg/30',
                        ].join(' ')}
                    >
                        <Icon size={20} stroke={1.5} />
                        <span className="text-sm font-medium">{t(labelKey)}</span>
                        <span className="text-xs text-fg/68">{t(taglineKey)}</span>
                        <span
                            className={[
                                'absolute top-3 right-3 h-3 w-3 rounded-full border',
                                selected ? 'border-blue-500 bg-blue-500' : 'border-fg/40',
                            ].join(' ')}
                            aria-hidden="true"
                        />
                    </button>
                );
            })}
        </div>
    );
}
